import { lazy } from 'react';

const HelpCenterPage = lazy(() => import('./pages/HelpCenterPage'));

export const HelpCenterEntry = () => <HelpCenterPage />;
